import type { MenuProps } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { useStoreActions } from '../../store';
import { createUseStyles } from 'react-jss';
import { useEffect, useState } from 'react';

const useStyles = createUseStyles({
  locale: {
    marginLeft: '10px',
    marginRight: '8px',
    verticalAlign: 'top',
    cursor: 'pointer',
    transition: 'all .3s',
  },
  icon: {
    fontSize: '1.2em',
  },
});

export const Translate = () => {
  const setCurrentLang = useStoreActions((actions) => actions.i18n.setCurrentLang);
  const classes = useStyles();
  const [isScript1Loaded, setScript1Loaded] = useState(false);
  //const [isScript2Loaded, setScript2Loaded] = useState(false);

  useEffect(() => {
    const script1 = document.createElement('script');
    script1.src = 'https://global.localizecdn.com/localize.js';
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      setScript1Loaded(true);
    };

    const script2 = document.createElement('script');
    script2.innerHTML = `
        !function(a){
          if(!a.Localize){
            a.Localize={};
            for(var e=["translate","untranslate","phrase","initialize","translatePage","setLanguage","getLanguage","detectLanguage","getAvailableLanguages","untranslatePage","bootstrap","prefetch","on","off","hideWidget","showWidget","getSourceLanguage"],t=0;t<e.length;t++)a.Localize[e[t]]=function(){}
          }
        }(window);
      `;
    document.head.appendChild(script2);
    //script2.onload = () => {setScript2Loaded(true)};
  }, []);

  if (isScript1Loaded) {
    (window as any).Localize.on('setLanguage', function (data: any) {
      // Persist the currently selected language choice
      setCurrentLang(data.to);
    });
  }

  const items: MenuProps['items'] = [
    {
      key: 'en',
      label: (
        <span>
          <span role="img" aria-label="English">
            🇺🇸
          </span>
          English
        </span>
      ),
    },
    {
      key: 'es-MX',
      label: (
        <span>
          <span role="img" aria-label="Español">
            🇪🇸
          </span>
          Español
        </span>
      ),
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    if (isScript1Loaded) {
      (window as any).Localize.setLanguage(key);
      (window as any).Localize.initialize({
        key: 'SUCVUriyQJXbs',
        rememberLanguage: true,
        autoApprove: true,
        targetLanguage: key || 'en',
        disableWidget: true,
        // other options go here, separated by commas
      });
    }
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <Dropdown menu={menuProps}>
      <span className={classes.locale}>
        <GlobalOutlined className={classes.icon} />
      </span>
    </Dropdown>
  );
};
